"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getEngagementEventType = getEngagementEventType;
exports.getIsEngagement = getIsEngagement;
exports.getEventType = getEventType;

var _TimelineConstants = require("crm_universal/timeline/TimelineConstants");

function getTimelineItemEventType(timelineItem) {
  return timelineItem.get('etype');
}

function getEngagementEventType(engagement) {
  return engagement.getIn(['engagement', 'type']).toLowerCase();
}

function getIsEngagement(timelineItem) {
  return timelineItem.get('etype') === _TimelineConstants.EVENT_ENGAGEMENT;
}

function getEventType(timelineItem) {
  return getIsEngagement(timelineItem) ? getEngagementEventType(timelineItem.get('eventData')) : getTimelineItemEventType(timelineItem);
}